bcn.scroll = (function () {

'use strict';

var headerSelector = '[data-fixed-header]',
  fixedClass = 'fixed-header--show',
  shrinkOn = 300;

function fixOnScroll () {
  window.addEventListener('scroll', function () {
    var distanceY = window.pageYOffset || document.documentElement.scrollTop;

    if (distanceY > shrinkOn) {
      $(headerSelector).addClass(fixedClass);
    } else {
      $(headerSelector).removeClass(fixedClass);
    }
  });
}

function scrollLinks () {
  $('[data-scroll-to]').on('click', function (e) {
    e.preventDefault();
    var target = $(this.hash);
    var scrollValue = $(this).data('scroll-offset') ? target.offset().top - parseInt($(this).data('scroll-offset'), 10) : target.offset().top;

    if( $(this).data('scroll-offset-mobile') === false && window.innerWidth <= 768) {
      scrollValue = target.offset().top;
    }

    $('html,body').animate({
      scrollTop: scrollValue
    }, 300);

    if (!target.is('input')) {
      target.attr('tabindex', -1);
    }
    target.focus();
  });
}

return {
    init: function () {
      fixOnScroll();
      scrollLinks();
    }
  };

})();
